import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common-services/common.service';


@Component({
  selector: 'app-interest-update-dialog',
  templateUrl: './interest-update-dialog.component.html',
  styleUrls: ['./interest-update-dialog.component.scss']
})
export class InterestUpdateDialogComponent {
  interestsList: any[] = [];

  constructor(private dialogRef: MatDialogRef<InterestUpdateDialogComponent>, private service: CommonService, @Inject(MAT_DIALOG_DATA) public data: any ) { }

  closeDialog(isTrue: Boolean) {
    this.dialogRef.close({isTrue:isTrue, data:this.interestsList});
  }
  ngOnInit() {
    if(this.data){
      this.interestsList = this.data.data;
    }
  }
  toggleValueCheck(ev:any, values:any){
    values.isChecked = ev.target.checked
  }
}
